var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banxx",staticStyle:{"background":"url('/images/yrxm.jpg') no-repeat center center","background-size":"cover"}}),_c('vue-menu',{attrs:{"menu":_vm.menu,"title":"产品服务","menuWidth":350}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }